<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Header
      title="Card menu"
      :showGoBack="true"
    />

    <main
      class="scrollable container"
      :style="{paddingTop: '10px'}"
    >
      <!-- Cards -->
      <section :style="{marginBottom: '30px'}">
        <span
          class="t14"
          :style="{marginBottom: '10px', display: 'block'}"
          >Cards</span
        >
        <ul
          :style="{
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            rowGap: '11px',
          }"
          :class="'row-center'"
        >
          <li
            :key="card.id"
            class="clickable"
            v-for="card in cards"
            :style="{width: 'calc(100% / 2 - 5.5px)'}"
            @click="() => $router.push(routes.CARD_DETAILS)"
          >
            <img
              :src="card.image"
              :style="{width: '100%', height: 'auto', borderRadius: '10px'}"
            />
          </li>
        </ul>
      </section>

      <!-- Ongoing credits -->
      <section :style="{marginBottom: '30px'}">
        <span
          class="t14"
          :style="{marginBottom: '10px', display: 'block'}"
          >Ongoing credits</span
        >
        <ul
          :style="{
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            rowGap: '11px',
          }"
          :class="'row-center'"
        >
          <li
            :key="card.id"
            class="clickable"
            v-for="card in ongoingCards"
            :style="{width: 'calc(100% / 2 - 5.5px)'}"
            @click="() => $router.push(routes.CARD_DETAILS)"
          >
            <img
              :src="card.image"
              :style="{width: '100%', height: 'auto', borderRadius: '10px'}"
            />
          </li>
        </ul>
      </section>

      <!-- Entrepreneur accounts -->
      <section :style="{marginBottom: '30px'}">
        <span
          class="t14"
          :style="{marginBottom: '10px', display: 'block'}"
          >Entrepreneur accounts</span
        >
        <div
          :style="{
            gap: '10px',
            padding: '12px',
            borderRadius: '10px',
            backgroundColor: '#FFF7F2',
          }"
          :class="'row-center'"
        >
          <EnterpreneurAccSvg />
          <div class="column-start">
            <span class="t12">US**********************4571</span>
            <h6>39 863.62 USD</h6>
          </div>
        </div>
      </section>

      <!-- Button -->
      <Button
        title="+ Add new card"
        :colorSchema="'secondary'"
        @click="() => $router.push(routes.OPEN_NEW_CARD)"
      />
    </main>
  </div>
</template>

<script setup>
// components
import {Button} from '@/components';
import {Header} from '@/components';

// svg
import {EnterpreneurAccSvg} from '@/assets/svg';

// other
import {routes} from '@/routes';
import {useOpacity} from '@/hooks';
const opacity = useOpacity();

const cards = [
  {
    id: 1,
    image: require('@/assets/cards/03.png'),
  },
  {
    id: 2,
    image: require('@/assets/cards/04.png'),
  },
];

const ongoingCards = [
  {
    id: 1,
    image: require('@/assets/cards/06.png'),
  },
];
</script>
